module.exports = __webpack_public_path__ + "media/MRI18A.dc135b37.mp3";